export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref8149.1dedf4b2.jpg";